var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmarkBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "5 6 10 8"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.634 8.384a1.25 1.25 0 0 0-1.768-1.768L8.75 10.733 7.134 9.116a1.25 1.25 0 0 0-1.768 1.768l2.5 2.5a1.25 1.25 0 0 0 1.768 0z"
})));
export default SvgCheckmarkBold;